
<style>


.footer-h4, .footer-h5{
  color: #ececec !important; 
}

.footer-row{
  display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: flex-start;

}

.social-icons{
  background-color: transparent !important;
  border: none !important;
}

.social-icons:hover{
  background-color: transparent !important;
}

@media (min-width: 1090px) {
.text-footer {
    font-family: sans-serif !important;
    font-size: .7rem !important;
}
.footer-bottom {
    display: flex;
    text-align: center;
  
  }

  .footer-bottom > a{
    text-align: center !important;
  }

}

@media screen and (max-width: 782px) {

.social-icons{
  width: 20%;
  background-color: transparent !important;
  border: none !important;
}

.social-media-icon-wrap{
  width: 100%;
  padding-bottom: 1%;
}

}

</style>

<template>
  <div id="footer-bar">
    <footer>
      <div class="container">
        <div class="pt-5">
          <h4 class="mb-4 footer-h4">CalMed Hawaii</h4>
          <hr style="border: 1px solid #ffffff90 !important" />
        </div>
        <div class="row">
          <div class="col-sm-3">
            <div class="mb-4">
              <br />
              <p class="d-md-block footer-text">
                CalMed Hawaii
                <br />3049 Ualena Street <br />Unit 101, First Floor
                <br />Honolulu, HI 96819-1942 <br />P
                <a href="tel:+18086919973">(808) 691-9973</a> |<br />
                F (888) 286-7412
                <br />
              </p>
            </div>
          </div>
          <div class="col-sm-3">
            <div class="mb-4 ml-5">
              <h5 class="footer-h5">My Account</h5>
              <ul class="list-unstyled">
                <!-- <li>
                  <router-link
                    to="/site/signup"
                    active-class=""
                    class="py-2 d-block"
                    >Education Class Sign Up</router-link
                  >
                </li> -->

                <li>
                  <router-link
                    to="/cpapform"
                    active-class=""
                    class="py-2 d-block"
                    >Upload CPAP Prescription</router-link
                  >
                </li>
                <li>
                  <router-link to="/faq" active-class="" class="py-2 d-block"
                    >FAQ</router-link
                  >
                </li>
                <li>
                  <router-link
                    to="/careers"
                    active-class=""
                    class="py-2 d-block"
                    >Careers</router-link
                  >
                </li>
               
              </ul>
            </div>
          </div>
          <div class="col-sm-3">
            <div class="mb-4 ml-5">
              <h5 class="footer-h5">Customer Service</h5>
              <ul class="list-unstyled">
                <li>
                  <a href="/shop#!/Breast-Pumps/c/153505064" active-class="" class="py-2 d-block"
                    >Breast Pumps</a
                  >
                </li>
                <li>
                  <a href="/shop#!/CPAP-BIPAP/c/153505095" active-class="" class="py-2 d-block"
                    >Respiratory</a
                  >
                </li>
                <li>
                  <router-link
                    to="/lactation_edn"
                    active-class=""
                    class="py-2 d-block"
                    >Lactation Education
                  </router-link>
                </li>
                <li>
                  <router-link
                    to="/lactation_res"
                    active-class=""
                    class="py-2 d-block"
                    >Lactation Resources
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-sm-3">
            <div class="mb-4 ml-5">
              <h5 class="footer-h5">More</h5>
              <ul class="list-unstyled">
                <li>
                  <router-link to="/about" active-class="" class="py-2 d-block"
                    >About Us</router-link
                  >
                </li>
                <li>
                  <router-link
                    to="/shipping-delivery"
                    active-class=""
                    class="py-2 d-block"
                    >Shipping & Delivery</router-link
                  >
                </li>
                <li>
                  <router-link to="/return" active-class="" class="py-2 d-block"
                    >Return Policy</router-link
                  >
                </li>
                <li>
                  <router-link to="/blog" active-class="" class="py-2 d-block">Blog</router-link>
                </li>
                 <!-- <img src="@/assets/site/images/joint-commission.png" style="width:33%;" class="img-fluid " alt=""> -->
         
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
    <section class="d-md-block">
      <div class="container">
        <div class="row pt-3">
          <div class="col-md-9">
            <div class="footer-row">
              <div class="footer-bottom">
                <router-link to="/privacy">
                  <p class="text-footer">PRIVACY POLICY </p>
                </router-link>
              </div>
              <div class="footer-bottom">
                <router-link to="/terms">
                  <p class="text-footer">TERMS & CONDITIONS</p>
                </router-link>
              </div>
              <div class="footer-bottom">
                <router-link to="/rights-responsibilities">
                  <p class="text-footer">RIGHTS & RESPONSIBILITIES</p>
                </router-link>
              </div>
             
              <!-- <div class="footer-bottom">
                <router-link to="/careers">
                  <p class="text-footer">CAREERS</p>
                </router-link>
              </div> -->
              <!-- <div class="footer-bottom">
                <router-link to="/faq">
                  <p class="text-footer">FAQ</p>
                </router-link>
              </div> -->
            </div>
          </div>
          <!-- <div class="col-md-4 text-center">©2024 CalMed Hawaii</div> -->
          <div class="social-media-icon-wrap" id="social-links">
           <div class="row justify-content-center">
              <div class="col-md-1 social-icons">
                <a href="https://www.facebook.com/CalMed-Hawaii-277028104107983/" target="_blank">
                <i class="fa fa-facebook" aria-hidden="true"></i>
                </a>
              </div>
              <div class="col-md-1 social-icons">
                <a href="https://goo.gl/maps/3MD5h2BcSF63qFTJ6" target="_blank">
                <i class="fa fa-google" aria-hidden="true"></i>
                </a>
              </div>
              <div class="col-md-1 social-icons">
                <a href="https://www.instagram.com/calmedhawaii/" target="_blank">
                <i class="fa fa-instagram" aria-hidden="true"></i>
                </a>
              </div>
              <div class="col-md-1 social-icons">
                <a href="https://www.pinterest.com/Calmedhawaii/" target="_blank">
                <i class="fa fa-pinterest-p" aria-hidden="true"></i>
                </a>
              </div>
             
            </div>
          </div>
          
        </div>
      </div>
      <!-- <back-to-top bottom="50px" right="50px">
        <button type="button" class="btn btn-info btn-to-top">
          <i class="fa fa-chevron-up"></i>
        </button>
      </back-to-top> -->
    </section>
  </div>
</template>
<script>
import BackToTop from "vue-backtotop";
export default {
  name: "FooterBar",
  components: { BackToTop },
};
</script>
<style scoped>
.btn {
    cursor: pointer;
    border-radius: 5px  !important;
    box-shadow: none !important;
}
</>
